import { render, staticRenderFns } from "./ModalSolicitacaoDeOrcamento.vue?vue&type=template&id=4b0ad1d4&scoped=true"
import script from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalSolicitacaoDeOrcamento.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalSolicitacaoDeOrcamento.vue?vue&type=style&index=0&id=4b0ad1d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0ad1d4",
  null
  
)

export default component.exports